const colors = {
	green: '#2AA14C',
	yellow: '#F7CD62',
	greenYellow: '#98b54c',
	black: '#130f18',
	white: '#fff',
};

export default colors;
